import axios from 'axios'
import { useState } from 'react'
import { constants } from '../../Constants'
import { Button, Modal } from '../ui'
import { useToast } from '../ui/Toast/Toast'

export const ModalCreateCommunication = ({ loadCommunications }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [messageTitle, setMessageTitle] = useState('')
  const [messageBody, setMessageBody] = useState('')
  const [visible, setVisible] = useState(true)
  const [loading, setLoading] = useState(false)
  const toast = useToast()

  const handleClose = () => {
    setIsOpen(false)
    setMessageTitle('')
    setMessageBody('')
    setVisible(true)
  }

  const createCommunication = async () => {
    if (!messageTitle.trim() || !messageBody.trim()) {
      toast({
        title: 'Campos requeridos',
        description: 'El título y el cuerpo son obligatorios.',
        status: 'error',
      })
      return
    }
    setLoading(true)
    try {
      await axios.post(`${constants.urlLocal}communications/create`, {
        title: messageTitle,
        content: messageBody,
        visible: visible,
      })
      toast({ title: 'Comunicación creada correctamente', status: 'success' })
      handleClose()
      loadCommunications?.()
    } catch (error) {
      toast({
        title: 'Error al crear la comunicación',
        description: error.response?.data?.message || 'Inténtalo de nuevo',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Button variant="primary" onClick={() => setIsOpen(true)}>
        Crear Mensaje
      </Button>
      <Modal isOpen={isOpen} onClose={handleClose} title="Crear Mensaje">
        <div className="form-group">
          <label className="form-label">Título del Mensaje *</label>
          <input
            className="form-input"
            value={messageTitle}
            onChange={e => setMessageTitle(e.target.value)}
            placeholder="Introduce el título"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Cuerpo del Mensaje *</label>
          <textarea
            className="form-textarea"
            value={messageBody}
            onChange={e => setMessageBody(e.target.value)}
            placeholder="Escribe tu mensaje aquí"
          />
        </div>
        <label className="form-checkbox">
          <input
            type="checkbox"
            checked={visible}
            onChange={e => setVisible(e.target.checked)}
          />
          Mostrar comunicado
        </label>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
            marginTop: '1rem',
          }}
        >
          <Button variant="ghost" onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={createCommunication}
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar Mensaje'}
          </Button>
        </div>
      </Modal>
    </>
  )
}
